import { Component, Input, OnInit } from '@angular/core';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { NbDateService } from '@nebular/theme';
import { addDays} from 'date-fns';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router} from '@angular/router';
import { environment } from '../../../../environments/environment';
import * as gender from './../../../data/gender.json';
import { RolesData } from '../../../@core/interfaces/common/roles';
import * as multilanguage from './../../../data/multilanguage.json';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { DepartmentData } from '../../../@core/interfaces/masters/department';
@Component({
  selector: 'ngx-portal-appointment-booking-component',
  templateUrl: './portal-appointment-booking-component.component.html',
  styleUrls: ['./portal-appointment-booking-component.component.scss','../../../../assets/css/patient-portal.css']
})
export class PortalAppointmentBookingComponent implements OnInit {
  
  protected readonly unsubscribe$ = new Subject<void>();

  drScheduleList: Array<any> = [];
  drAvailablityist: Array<any> = [];
  drBookedAppointmentLists: Array<any> = [];
  bookingPlatFormApp: FormGroup;
  bookedAptDates:  Array<any> = [];
  events : Array<any> = [];
  leaveEvents: Array<any> = [];
  noOfDaysToAdd=5;
  dateListArrayData: Array<{id:number, date: Date,isSelected:boolean ,isActive:boolean,doctorId:string}> = [];
  doctorSlotList: Array<{id:number, date: Date,isSelected:boolean ,doctorId:string,type:string}> = [];
  doctorLists: Array<{
    slotList: { id: number; date: Date; isSelected: boolean; isActive: boolean; doctorId: string; }[];doctorName:string, specialities: string,departmentName:string ,endTime:string,startTime:string,endDate:string,startDate:string,
    dayOfWeek:string,imageLink:string,
    experience:string,languages:string, education:string ,hospitalName:string , doctorId:string ,
    isSelected:boolean,isActive:boolean,visitType:string,hospitalCity:string}> = [];
    originalDoctorLists:Array<any>=[];

  chips: Array<{ date: Date, duration: number,doctorId:string,fromDate:Date,toDate:Date,isSelected:boolean,isActive:boolean }> = [];
  weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  doctorSlotsData: Array<any> = [];
  noSlotsAvailableMessage:string="No Slots Available";
  listedDoctorForAppointment: Array<any> = [];
  drAppointmentCountData: Array<any> = [];
  selectedSlot:any;
  selectedDate:any;
  durationForBooking:string;
  fromPortal:string;
  selectedSlotForEdit:Array<any>;
  selectedDateForEdit:string;
  selectedDrId:string;
  selectedId:string;
  isSelected:string;
  count:number=0;
  fromPortalFlag:boolean=false;
  vaccineList:Array<any>=[];
  departmentData : Array<any>=[];
  experienceData: Array<any> = [
    { id: '0-6 months'},
    { id: '1-2 years' },
    { id: '3-5 years'},
    { id: '5+ years'},
    { id: '10+ years'},
  ];
  clinicalType:Array<any>=[{'id':1,'name':'Clinic'},{'id':2,'name':'Video'}]
  selectedIndex: string;
  resetData:Array<any>=[];
  languageData:string[]=(multilanguage as any).default;
  datearg:Date=new Date(new Date().setDate(new Date().getDate() + 1));
  currentPage: number = 0;
  itemsPerPage: number = 6; 
  paginationId: string;
  selectedIn: number;
  oldDocId: string;
  doctorPagination: { [key: string]: number } = {};
  slotValue:Array<any>=[];
  genderList: string[]= (gender as any).default;
  selectDate:string;
  vaccineFlag:boolean = false;
   consulationList:Array<any>=[];
  mental:boolean=false;
  primary:boolean=true;
  mentalplace:string=''
  mentalHealth :Array<any>=["Sadness","Emptiness","Hopelessness","Worries or Fear","Guilty feelings or worthlessness","Irritability or anger","Difficulty concentrating or making decisions","Confused thinking or unusual thoughts","Delusions or Hallucinations","Problems with memory","Slowed thinking or Speech","Loss of interest in activities","Increased sensitivity","Self-harm/suicidal thoughts","Social withdrawal",
  "Poor hygiene or self care","Unusual or erratic behaviour","Fatigue or low energy"];

  primaryCare:Array<any>=['Diabetes','Hypertension','Heart disease','Cancer','Lungs','Stomach pain','Fever','Cough','Cold','Headache'];
  imageLinkList: Array<any>=[];
  @Input() bookingPath:string;
  @Input() city:string;
  @Input() region:string;
  @Input() isPatientDoc:boolean=false;
  isBookAndReview:string='booking'; //booking, review 
  visitDetails: any = {};
  hospitalList:Array<any>=[];
  hospitalFilteredList:Array<any>=[];
  filteredDocList:Array<any>=[];
  selectedDocId: string = '';
  selectedTenantId: string = '';
  selectedImageLink: any = '';
  isDocDetailsVisible: boolean = false;
  countryCode:string='';
  constructor(private route: ActivatedRoute,private getDrAppointmentService: PatientAppointmentData,private datePipe: DatePipe, protected deptSrvc: DepartmentData, private rolesService:RolesData,private toaster: ToastrAppSrvcService,
    protected nbDateServiceObj: NbDateService<Date>,private fb: FormBuilder,public dateService: DateService,public router: Router) { 

      this.route.queryParams.subscribe(params => {
        if (params['cc']) {
          this.countryCode = params['cc']; 
        }
      });

    this.bookingPlatFormApp = this.fb.group({
      chiefComplaintID: new FormControl(null),
      departmentOrDoctor: new FormControl(null),
      location: new FormControl(null),
      date: new FormControl(new Date()),
      startDate: new FormControl(new Date()), 
      endDate: new FormControl(new Date()), 
      doctorId: new FormControl(null),
      visitType: new FormControl("Clinic"),
      departmentId:new FormControl(null),
      experinceTerm:new FormControl(null),
      specialityTerm:new FormControl(null),
      typeTerm:new FormControl(null),
      languageTerm:new FormControl(null),
      vaccines:new FormControl(null),
      clinicandvideo:new FormControl(null),
      hospital:new FormControl(null),
      typeList:new FormControl(null),

    });
  }
  resetOnload(){
    this.doctorLists = [];
    this.drAvailablityist=[];
    this.drBookedAppointmentLists=[];
    this.drScheduleList=[];
    this.dateListArrayData=[];
    this.chips=[];
    this.resetData=[];
    this.doctorPagination={};
    localStorage.removeItem('selectedDateForEdit');
    localStorage.removeItem('selectedDrId');
    localStorage.removeItem('selectedId');
    localStorage.removeItem('isSelected');
    localStorage.removeItem('visiType');
    localStorage.removeItem('visitIndex');
    localStorage.removeItem('isBooked');
    localStorage.removeItem('dataListArrayData');
    localStorage.removeItem('pagination');
  }

  ngOnInit(): void {
    this.LoadVaccine();
    this.fromPortal = this.route.snapshot.params.value1;
    this.fromPortalFlag = false;

    this.route.queryParams.subscribe(params => {
    if (params['cc']) {
      this.countryCode = params['cc']; 
    }
  });
    
    if(this.fromPortal=='fromPortalEdit'){
      this.vaccineFlag = localStorage?.getItem('visiType')=='Vaccine'?true:false;
      this.fromPortalFlag = true;
      var doctor = localStorage.getItem('doctor');
      var vacc = this.vaccineFlag?JSON.parse(localStorage.getItem('VaccineDet')):'';
      var location = localStorage.getItem('location');
      this.bookingPlatFormApp.get('departmentOrDoctor').setValue(!!doctor && doctor!='null'?doctor:'');
      this.bookingPlatFormApp.get('vaccines').setValue(!!vacc && vacc!='null'?(vacc?.id):'');
      this.bookingPlatFormApp.get('location').setValue(location&&location!='null'?location:'');
      localStorage.getItem('dataListArrayData');
      const editlist = JSON.parse(localStorage.getItem('dataListArrayData') || '[]')
      ?.filter((x) => x.doctorId === localStorage.getItem('selectedDrId'));
    
    if (editlist && editlist.length) {
      // this.dateListArrayData.push(...editlist);
      this.doctorPagination[localStorage.getItem('selectedDrId')] = Number(localStorage.getItem('pagination')); 
    }
    }
    this.loadAllDoctorImages();
  }

  ngOnChanges(){
    this.isBookAndReview = 'booking';
    this.isDocDetailsVisible = false;
    if(this.bookingPath){
      if(this.bookingPath === 'doc'){
        if(this.city && this.region && !this.isPatientDoc){
          this.bookingPlatFormApp.get('location').setValue(this.city);
          this.getDoctorList();
        } else{
          this.vaccineFlag = false;
          this.primary = true;
          this.mental = false;
          this.loadData('primary');
        }
        
      } else if(this.bookingPath === 'mental'){
        this.vaccineFlag = false;
        this.primary = false;
        this.mental = true;
        this.loadData('mental');
        this.getDoctorList('psy');
      }
      else if(this.bookingPath === 'vaccination'){
        this.vaccineFlag = true;
        this.primary = false;
        this.mental = false;
        this.loadData('Vaccine');
      }else{
        this.vaccineFlag = false;
        this.primary = true;
        this.mental = false;
        this.loadData('primary');
        this.getDoctorList('gen');
      }
    }
  }

  get formValidation(): { [key: string]: AbstractControl } { return this.bookingPlatFormApp.controls; }

  iterateDate(startDateParam,doctorId,noofdays?){
   
    var startDateValue = new Date();
    if(startDateParam !=null ){startDateValue=startDateParam; }
    var endDate = addDays(startDateValue, (this.vaccineFlag?noofdays:this.noOfDaysToAdd));
    var dates = this.getDateList(startDateValue, endDate,doctorId);
    return dates;
  }

  getDateList(startDate, endDate,doctorId) :void{
    let i=1;
      while (startDate <= endDate) {
      var dateArray= new Date(startDate.setDate(startDate.getDate()));
      this.dateListArrayData.push({id:i++, "date": dateArray,  isSelected : false ,isActive:true, doctorId:doctorId});
      new Date(startDate.setDate(startDate.getDate() + 1));
    }
    
  }

  updateList(index: number, visitType: string) {
    this.doctorLists[index].visitType = visitType;
}


getDoctorSlots(doctorId: string, det?) {
  if (doctorId != null && doctorId !== "" && doctorId !== undefined) {
    const id = localStorage.getItem('selectedDrId');      
    const currentPage = this.doctorPagination[doctorId] || 0;

    // Get base list for this doctor
    let slotList = this.dateListArrayData?.filter(
      e => e.doctorId === doctorId && e.isActive === true
    );

    // Apply vaccine day filter if applicable
    if (this.vaccineFlag && det) {
      const allowedDaySet = new Set(det.split(",").map(day => day.trim()));
      slotList = slotList.filter(slot => {
        const day = new Date(slot.date).toLocaleString('en-US', { weekday: 'long' });
        return allowedDaySet.has(day);
      });
    }

    // Apply pagination
    const paginationIndex = (this.fromPortal === 'fromPortalEdit' && doctorId === id)
      ? this.doctorPagination[id]
      : currentPage;

    return slotList?.slice(paginationIndex, paginationIndex + 6);
  }

  return [];
}

 LoadVaccine():void{
if(this.vaccineList?.length > 0) return;
  this.rolesService.list("vaccine/" + environment.tenantId + '/' + environment.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.vaccineList = data;

  }, (error) => {

  }, () => {

  }); 

 }

 joinDateAndTime(dateStr: string, timeStr: string): Date {
  const [datePart] = dateStr.split('T');
  const dateTime = `${datePart}T${timeStr}Z`;
  return new Date(dateTime);
}
 getSlotDays(start: Date, end: Date): number {

  const diffMs = end.getTime() - start.getTime();

  // Convert to days and add 1 to include both start and end date
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;

  return diffDays;
}

loadAllDoctorImages(){
  this.rolesService.list("ImageAtchDet/" + environment.patientTenantId +'/null/all').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.imageLinkList = data;

  }, (error) => {
    // if(this.bookingPath === 'vaccination'){
    //   this.getDoctorList();
    // }
  }, () => {
    // if(this.bookingPath === 'vaccination'){
    // this.getDoctorList();
    // }
  }); 
}


  getDoctorList(pageName?:string): void {
    if(this.vaccineFlag){
      if(this.bookingPlatFormApp.get('vaccines').value == '' || this.bookingPlatFormApp.get('vaccines').value == undefined || this.bookingPlatFormApp.get('vaccines').value == null) {
        this.toaster.ForDanger('Please Select Vaccine')
        return ;}
    }

   
    localStorage.removeItem('doctor');
    localStorage.removeItem('location');
    var data = {
      // "doctDeptName": this.bookingPath === 'mental' && !this.bookingPlatFormApp.get('departmentOrDoctor').value?'psy':this.bookingPath === 'doc' && !this.bookingPlatFormApp.get('departmentOrDoctor').value?'gen':this.bookingPlatFormApp.get('departmentOrDoctor').value,
      "doctDeptName": (this.bookingPlatFormApp.get('departmentOrDoctor')?.value||this.bookingPath === 'vaccination')?this.bookingPlatFormApp.get('departmentOrDoctor').value:pageName,
      "location": this.bookingPlatFormApp.get('location').value,
      "type":"search",
      "countryCode":this.countryCode
    }
    localStorage.setItem('doctor',this.bookingPlatFormApp.get('departmentOrDoctor').value);
    localStorage.setItem('location',this.bookingPlatFormApp.get('location').value);
    const searchurl = this.vaccineFlag?'getAvailableDrListForVaccine':'getAvailableDrList'
    this.getDrAppointmentService.searchList(`bookingPlatform/${searchurl}`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(apts => {
     if (this.vaccineFlag) {
          apts = apts?.map(x => {
            return { ...x, visitType: 'Vaccine' };
          });
        }
      this.doctorLists = apts;
      this.originalDoctorLists =apts;
      this.hospitalList = apts;
      this.hospitalFilteredList = this.hospitalList.filter((thing, i, arr) => arr.findIndex(t => t.hospitalName === thing.hospitalName) === i);
      this.doctorLists.forEach(eachDoc => {
        const downloadData = this.imageLinkList.find(img => img.phyId === eachDoc.doctorId)?.imageLink || '';
        if(downloadData) eachDoc.imageLink = 'data:image/jpeg;base64,' + downloadData;
        else eachDoc.imageLink = '';
      })
      this.resetData=apts
      if(this.fromPortal!='fromPortalEdit'){
        this.doctorLists.forEach(doctor => {
          doctor.visitType = this.vaccineFlag?'Vaccine':'Clinic';
        });
        this.dateListArrayData=[];
      }else{
        this.doctorLists.forEach(doctor => {
          doctor.visitType = this.vaccineFlag?'Vaccine':'Clinic';
        });
        const index = localStorage.getItem('visitIndex')
        setTimeout(()=>{this.doctorLists[index].visitType = localStorage.getItem('visiType')},500)
      }    
      this.drAvailablityist=[];
      this.drBookedAppointmentLists=[];
      this.drScheduleList=[];
      // this.dateListArrayData=[];
      this.chips=[];

      if(this.doctorLists?.length>0){
        this.selectedDate = null;
        this.selectedIndex='';        
    this.doctorLists.forEach(element => {
       if(this.vaccineFlag){
        const start = this.joinDateAndTime(new Date().toISOString(),element?.startTime);
        const end = this.joinDateAndTime(element?.endDate,element?.endTime)
        const noOfDays = this.getSlotDays(start,end);
        element.isActive=true,element.isSelected=false,
      this.iterateDate(start,element.doctorId,noOfDays);
       }else{
element.isActive=true,element.isSelected=false,
      this.iterateDate(new Date(),element.doctorId);
       }
      
   });
   this.doctorLists.forEach((element, index) => {
    element.slotList = this.getDoctorSlots(element.doctorId,element?.dayOfWeek);
  })
      }
      if(this.fromPortal=='fromPortalEdit'){
        var date = new Date(localStorage.getItem('selectedDateForEdit'));
      var docId = localStorage.getItem('selectedDrId');
      var id = Number(localStorage.getItem('selectedId'));
      var isSelected = Boolean(localStorage.getItem('isSelected'));
      var isBooked = Number(localStorage.getItem('isBooked'));

      this.searchSlotLists(date,docId,id,false,isBooked);
      this.getSlotTime(JSON.parse(localStorage.getItem('slotData')));
      }
      
    }, (error) => {
      if(error.status === 401){
        this.router.navigate(['auth/patient-portal']);
      }
    }, () => {
    });
      
    if(!this.bookingPlatFormApp.get('location').value && !this.bookingPlatFormApp.get('departmentOrDoctor').value){
      this.doctorLists = [];
      this.drAvailablityist=[];
      this.drBookedAppointmentLists=[];
      this.drScheduleList=[];
      this.dateListArrayData=[];
      this.chips=[];
      this.resetData=[];

    }

  }

  getSlotTime(x){
    this.count= 1;
      localStorage.removeItem('slotData');
      var myArray = JSON.parse(JSON.stringify(x));
      myArray.date = new Date(myArray.date);
      myArray.date  = myArray.date.toISOString();
      localStorage.setItem('slotData',JSON.stringify(myArray));
      var storedDateString = JSON.parse(localStorage.getItem('slotData'));
      storedDateString.date = new Date(storedDateString.date);
      this.selectedSlotForEdit = storedDateString;
    if(this.fromPortal=='fromPortalEdit'){
      x.date = new Date(x.date);
    }
    
 
  this.chips.forEach(e=>e.isSelected=false);
  x.isSelected=true;
  this.durationForBooking = x.duration;
  this.selectedDateForHglt = x.date;
  this.selectedDate = x.date.toISOString();
  this.selectedIndex = x.doctorId;
  this.selectedSlot = this.getStartTime(x.date.getHours()+':'+(x.date.getMinutes()<10?'0'+x.date.getMinutes():x.date.getMinutes()).toString())
  }



convertIntoAMPM(date){
  return( this.getStartTime(date.getHours()+':'+(date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()).toString()));
}

getDoctorAppointmentCount(doctorId,date){
let fromDate= this.dateService.utcFromDate(date);
let toDate= this.dateService.utcToDate(date);

var returnData= this.drAppointmentCountData.filter(e=>e.doctorId===doctorId && e.date>=fromDate && e.date <=toDate)?.length;
return returnData;
}

searchSlotListsMuptipleDrs(doctorLists){
  this.listedDoctorForAppointment=[];
  doctorLists.forEach(e => {
    this.listedDoctorForAppointment.push(e.doctorId);
  });
  var todateValue = new Date();
  todateValue.setDate(todateValue.getDate() +this.noOfDaysToAdd);

  var data = {

    "fromDate": this.dateService.utcFromDate(new Date()),
    "toDate": this.dateService.utcToDate(new Date()),
    "doctorId": this.listedDoctorForAppointment,
    "apptCountFromDate": this.dateService.utcFromDate(new Date()),
    "apptCountToDate": this.dateService.utcToDate(todateValue),
  }

  this.getDrAppointmentService.searchList(`bookingPlatform/GetMultipleDoctorScheduleSlots`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(apts => {
    this.drBookedAppointmentLists=[...apts.appointments];
    this.drScheduleList.push(...apts.schedule);
    this.drAvailablityist=[...apts.availability];
    this.drAppointmentCountData=apts.currentPatientAppt;
    this.bookedAptDates = [];
    this.drBookedAppointmentLists.forEach(apts => {
      let aptdate: Date = this.dateService.dateUtctoLocalDateAndTime(apts.date);
      let timeOnly: any = this.dateService.dateUtctoLocalTimeOnly(aptdate);
      this.bookedAptDates.push(this.convertToDateType(aptdate, timeOnly.toString()));
        
    
    });
  //  this.getSlots(doctorId);

  }, (error) => {

  }, () => {
  });
}


searchSlotLists(date,doctorId,id,isSelected,index){
  if(this.fromPortal == 'fromPortalEdit'){
    this.count++;
    this.dateListArrayData.filter(e=>e.isSelected==true).forEach(e=>e.isSelected=false);
  }
  this.selectedDateForEdit = date;
  this.selectedDrId = doctorId;
  this.selectedId = id;
  this.isSelected = isSelected;
  this.selectedIn = index;
  this.selectDate = date;
 
  this.chips=[];
 this.dateListArrayData.filter(e=>e.doctorId==doctorId && e.isSelected==true).forEach(e=>e.isSelected=false);
 if(isSelected){
  this.selectedDate=null;
  this.doctorLists.filter(e=>e.doctorId===doctorId).forEach(e=>e.isSelected=false);
  this.dateListArrayData.filter(e=>e.doctorId==doctorId && e.id==id).forEach(e=>e.isSelected=false); }
 else{this.dateListArrayData.filter(e=>e.doctorId==doctorId && e.isSelected==false && e.id==id).forEach(e=>e.isSelected=true);
  this.doctorLists.filter(e=>e.doctorId===doctorId).forEach(e=>e.isSelected=true);
  

  var data = {
    "fromDate": this.dateService.utcFromDate(date),
    "toDate": this.dateService.utcToDate(date),
    "doctorId": doctorId,
    "countryCode":this.countryCode
  }
  this.bookingPlatFormApp.get('date').setValue(date),
  this.bookingPlatFormApp.get('date').setValue(date),
  this.bookingPlatFormApp.get('startDate').setValue(date),
  this.bookingPlatFormApp.get('endDate').setValue(date),
  this.bookingPlatFormApp.get('doctorId').setValue(doctorId),
  this.getDrAppointmentService.searchList(`bookingPlatform/GetDoctorScheduleSlots`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(apts => {
    this.chips.filter(e=>e.doctorId==doctorId).forEach(x=>x.isActive=false);
    this.drBookedAppointmentLists=[...apts.appointments];
    this.drScheduleList.push(...apts.schedule);
    this.drAvailablityist=[...apts.availability];
    this.bookedAptDates = [];
    this.drBookedAppointmentLists.forEach(apts => {
      let aptdate: Date = this.dateService.dateUtctoLocalDateAndTime(apts.date);
      let timeOnly: any = this.dateService.dateUtctoLocalTimeOnly(aptdate);
      this.bookedAptDates.push(this.convertToDateType(aptdate, timeOnly.toString()));    
    });

    this.getSlots(doctorId);

  }, (error) => {

  }, () => {
  });
}
  
}

bookVisit(i,docDet){
  this.isBookAndReview = 'review';
  localStorage.removeItem('selectedDateForEdit');
  localStorage.removeItem('selectedDrId');
  localStorage.removeItem('selectedId');
  localStorage.removeItem('isSelected');
  localStorage.removeItem('visiType');
  localStorage.removeItem('visitIndex');
  localStorage.removeItem('isBooked');
  localStorage.removeItem('dataListArrayData');
  localStorage.removeItem('docDet');
  localStorage.removeItem('pagination');
  localStorage.setItem('selectedDateForEdit',this.selectedDateForEdit);
  localStorage.setItem('selectedDrId',this.selectedDrId);
  localStorage.setItem('selectedId',this.selectedId);
  localStorage.setItem('isSelected',this.isSelected);
  localStorage.setItem('visiType',this.doctorLists[i]?.visitType);
  localStorage.setItem('visitIndex',i);
  localStorage.setItem('isBooked',`${this.selectedIn}`);
  localStorage.setItem('dataListArrayData',JSON.stringify(this.dateListArrayData));
  const det = this.doctorPagination[this.selectedDrId]|| 0
  localStorage.setItem('pagination',`${det}`)
  localStorage.setItem('selectDate',this.selectDate);
  localStorage.setItem('docDet',JSON.stringify(docDet));

  const dets = this.vaccineList.find(x => x?.id == this.bookingPlatFormApp.get('vaccines')?.value )
  localStorage.setItem('VaccineDet',JSON.stringify(dets));
}
isLinkValid(doctorId, date, slot, visitType, duration): boolean {
  return doctorId && date && slot && visitType && duration;
}

removeDuplicates(originalArray) {
  var newArray = [];
  var lookupObject = {};

  for (var i in originalArray) {
    lookupObject[originalArray[i]] = originalArray[i];
  }

  for (i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
}

convertToDateType(date: Date, value: string): Date {
  let splitData = value.split(':');

  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(splitData[0]), Number(splitData[1]));
}

selectedDateForHglt:string;
getDoctorChipsSlots(doctorId, type) {
  var dateArray = [];
  var returnData = [];
  if (this.chips.length > 0 && doctorId != undefined && doctorId != null && doctorId != "" && type != undefined) {

    let fromDate = this.dateService.utcFromDate(this.bookingPlatFormApp.get('startDate').value);
    let toDate = this.dateService.utcToDate(this.bookingPlatFormApp.get('endDate').value);
    returnData = this.chips.filter(e => e.doctorId == doctorId && e.isActive == true && e.fromDate >= new Date(fromDate) && e.toDate <= new Date(toDate));

    for (var i = 0; i < this.drBookedAppointmentLists.length; i++) {
      dateArray.push(this.dateService.dateUtctoLocalDateAndTime(this.drBookedAppointmentLists[i].date));
    }

    returnData = returnData.filter(mainItem =>
      !dateArray.some(secondItem =>
        mainItem.date && secondItem &&
        Math.abs(mainItem.date.getTime() - secondItem.getTime()) <= 60000
      )
    );

    const now = new Date();
    returnData.forEach(e => {
      e.isExpired = e.date < now;
    });

    if (this.fromPortal == 'fromPortalEdit') {
      returnData.forEach(jsonObj => {
        const dateStr = String(jsonObj.date).trim();
        const selectedDateStr = String(this.selectedDateForHglt).trim();

        if (dateStr == selectedDateStr) {
          jsonObj.isSelected = true;
        }
        if (this.count > 1) {
          jsonObj.isSelected = false;
        }
      });
    }

    if (type == "morning") {
      return returnData.filter(e => e.date.getHours() >= 0 && e.date.getHours() < 12);
    }
    else if (type == "afternoon") {
      return returnData.filter(e => e.date.getHours() >= 12 && e.date.getHours() < 16);
    }
    else if (type == "evening") {
      return returnData.filter(e => e.date.getHours() >= 16 && e.date.getHours() < 20);
    }
    else if (type == "night") {
      return returnData.filter(e => e.date.getHours() >= 20 && e.date.getHours() < 24);
    } else {
      return returnData;
    }
  }
}

getActiveSlots(doctorId,session){
  return this.getDoctorChipsSlots(doctorId, session)?.filter(slot => !slot.isExpired);
}




getSlots(doctorId:string): void {
  var doctorId=doctorId;
  this.events = [];
  this.leaveEvents = [];
  if (this.drScheduleList != null && this.drScheduleList != undefined && this.drScheduleList.length > 0) {
    this.drScheduleList.forEach(x => {
      let controlVal: Date = new Date((this.bookingPlatFormApp.controls['date'].value as Date));
      let date: Date = new Date(controlVal.getFullYear(), controlVal.getMonth(), controlVal.getDate());
      let ispresent = this.nbDateServiceObj.isBetween(date, new Date(x.startDate), new Date(x.endDate));
      let sameDate = (date.getTime() === new Date(x.startDate).getTime()
        || date.getTime() === new Date(x.endDate).getTime());
      if (ispresent || sameDate) {
            this.events.push({
              id: x.id + date.getDay().toString(),
              end_date: this.convertToDateType(date, x.endTime),
              start_date: this.convertToDateType(date, x.startTime),
              slot: x.timeSlotInMin,
              leave: false,
              doctorId:x.physician.id
            });
       
      }
    });
  }

  if (this.drAvailablityist != null && this.drAvailablityist != undefined && this.drAvailablityist.length > 0) {
    this.drAvailablityist.forEach(x => {
      let controlVal: Date = (this.bookingPlatFormApp.controls['date'].value as Date);
      let date: Date = new Date(controlVal.getFullYear(), controlVal.getMonth(), controlVal.getDate());

      let ispresent = this.nbDateServiceObj.isBetween(date, new Date(x.fromDate), new Date(x.toDate));
      let sameDate = (date.getTime() === new Date(x.fromDate).getTime()
        || date.getTime() === new Date(x.toDate).getTime());
      if (ispresent || sameDate) {
        let endTime = this.convertToDateType(date, x.endTime);
        let startTime = this.convertToDateType(date, x.startTime);
        let ele = this.events.filter(y => {

          let timeValidation: boolean = ((this.nbDateServiceObj.isBetween(startTime, y.start_date, y.end_date)) && (this.nbDateServiceObj.isBetween(endTime, y.start_date, y.end_date))) ||
            ((y.start_date.getTime() == startTime.getTime()) || (this.nbDateServiceObj.isBetween(endTime, y.start_date, y.end_date))) ||
            ((y.end_date.getTime() == endTime.getTime()) || (this.nbDateServiceObj.isBetween(startTime, y.start_date, y.end_date))) ||
            ((y.end_date.getTime() == endTime.getTime()) && (y.start_date.getTime() == y.start_date.getTime())) ||
            ((y.start_date.getTime() > startTime.getTime()) && (y.end_date.getTime() < endTime.getTime()));
          return timeValidation;

        });
        if (ele !== null && ele !== undefined) {
          ele.forEach(i => {

            this.events.splice(this.events.findIndex(x => x.id == i.id), 1);
          });
        }
        if ((x.available as any) === "true") {
          this.events.push({
            id: x.id + date.getDay().toString(),
            end_date: this.convertToDateType(date, x.endTime),
            start_date: this.convertToDateType(date, x.startTime),
            slot: x.timeSlotInMin,
            leave: false,
            doctorId:x.physician.id
          });
        }
        else {
          this.leaveEvents.push({
            id: x.id + date.getDay().toString(),
            end_date: this.convertToDateType(date, x.endTime),
            start_date: this.convertToDateType(date, x.startTime),
            slot: x.timeSlotInMin,
            leave: true,
            doctorId:x.physician.id
          });
        }
      }

    });
  }

  this.createTimeChips(doctorId);
}


 
createTimeChips(doctorId:string): void {
  this.chips = [];

  this.events.forEach(z => {
    let date: Date = z.start_date;
    this.chips.filter(e=>e.doctorId==doctorId).forEach(x=>x.isActive=false);
    while (date.getTime() < z.end_date.getTime()) {
      if (this.leaveEvents != null && this.leaveEvents != undefined && this.leaveEvents.length > 0) {
        this.leaveEvents.forEach(leave => {
          if (!(this.nbDateServiceObj.isBetween(date, leave.start_date, leave.end_date) && date.getTime() == leave.start_date.getTime())) {
            this.chips.push({ "date": date, duration: Number(z.slot),doctorId:z.doctorId,fromDate:new Date(this.dateService.utcFromDate(date)),isActive:true, isSelected : false,toDate:new Date(this.dateService.utcToDate(date)) });
          }
        });
      }
      else {
        this.chips.push({ "date": date, duration: Number(z.slot),doctorId: z.doctorId,fromDate:new Date(this.dateService.utcFromDate(date)),isActive:true, isSelected : false,toDate:new Date(this.dateService.utcToDate(date))});
      }

      date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes() + z.slot, 0);
    }
  });
  this.chips.sort((a, b) => 0 - (a.date.getTime() > b.date.getTime() ? -1 : 1));
  this.chips = this.chips.filter(
    (value, index, self) =>
      index === self.findIndex((v) => v.date.getTime() === value.date.getTime())
  );
 
}

onDisableBooked(date: Date, doctorId, apm, bookedCheck): any {
  if (apm) {

    return (this.getStartTime(date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()).toString()))

  } else {

    if (date.getTime() < new Date().getTime()) {
      return true;
    } else {
      return false;
    }

  }
}
 
idDisabled(date: Date, doctorId) {
  if (this.drBookedAppointmentLists != null && this.drBookedAppointmentLists != undefined && this.drBookedAppointmentLists.length > 0) {
    var apts = this.bookedAptDates?.filter(d =>
      this.datePipe.transform(d.date, 'yyyy-MM-dd') == this.datePipe.transform(date, 'yyyy-MM-dd'))

    var data1 = apts?.filter(d => d?.date?.getTime() == date?.getTime());
  }

}




getStartTime(input): string {

  var startDisplayTime;
  var endDisplayTime;
  if (input != null || input !== "") {
    startDisplayTime = input.split(':');
    var ampmStart = (startDisplayTime[0] >= 12 ? ' PM' : ' AM');
    startDisplayTime[0] = startDisplayTime[0] % 12;
    startDisplayTime[0] = (startDisplayTime[0] == 0 ? 12 : startDisplayTime[0]);
    startDisplayTime = startDisplayTime.join(':') + ampmStart;
    endDisplayTime = startDisplayTime;
  }

  else {
    endDisplayTime = ""

  }

  return endDisplayTime;
}

onstatus(index: number, type: string) {
  if (this.doctorLists[index]) {
      // Update only the visitType for the doctor at the specified index
      this.doctorLists[index].visitType = type;
  }
}

search() {
  this.doctorLists = this.resetData?.filter(doctor => {
    const matchesSpeciality = this.bookingPlatFormApp.get('specialityTerm').value
      ? doctor.departmentName?.toLowerCase().includes(this.bookingPlatFormApp.get('specialityTerm').value.toLowerCase())
      : true;
    const matchesType = this.bookingPlatFormApp.get('typeTerm').value
      ? doctor.gender?.toLowerCase() === this.bookingPlatFormApp.get('typeTerm').value.toLowerCase()
      : true;
      
    const experienceMatch = doctor.experience.match(/\d+/);
    const experienceYears = experienceMatch ? parseInt(experienceMatch[0], 10) : 0;
    const selectedExperience = this.bookingPlatFormApp.get('experinceTerm').value;
    const matchesExperience = selectedExperience
      ? (selectedExperience === '0-6 months' && experienceYears === 0) ||
        (selectedExperience === '1-2 years' && experienceYears >= 1 && experienceYears <= 2) ||
        (selectedExperience === '3-5 years' && experienceYears >= 3 && experienceYears <= 5) ||
        (selectedExperience === '5+ years' && experienceYears > 5 && experienceYears < 10) ||
        (selectedExperience === '10+ years' && experienceYears >= 10)
      : true;
    const matchesLanguage = this.bookingPlatFormApp.get('languageTerm').value
      ? doctor.languages?.toLowerCase().includes(this.bookingPlatFormApp.get('languageTerm').value.toLowerCase())
      : true;

    return matchesSpeciality && matchesType && matchesExperience && matchesLanguage;
  });
}

private getUniqueValues(key: string): string[] {
  return Array.from(new Set(this.doctorLists.map((doctor) => doctor[key].toLowerCase())));
}


hasNextSlots(doctorId: string, det?): boolean {
  if (!doctorId) return false;

  let slotList = this.dateListArrayData.filter(e => e.doctorId === doctorId && e.isActive === true);

  if (this.vaccineFlag && det) {
    const allowedDaySet = new Set(det.split(",").map(day => day.trim()));
    slotList = slotList.filter(slot => {
      const day = new Date(slot.date).toLocaleString('en-US', { weekday: 'long' });
      return allowedDaySet.has(day);
    });
  }

  const currentPage = this.doctorPagination[doctorId] || 0;
  const nextPageStart = currentPage + 6;

  return slotList.slice(nextPageStart, nextPageStart + 6).length > 0;
}

nextSchedule(date: Date, doctorId: string) {
  if (this.oldDocId !== doctorId) {
    
    this.doctorPagination[doctorId] = 0;
    this.doctorPagination[this.oldDocId] = 0;
    this.datearg = new Date();
    date = this.datearg;
  }
  
  const dateId = new Date(date.setDate(date.getDate() + 7));
  this.iterateDate(new Date(dateId), doctorId);

  if (this.fromPortal === 'fromPortalEdit' && doctorId === localStorage.getItem('selectedDrId') ) {
      this.doctorPagination[doctorId] = this.doctorPagination[doctorId]+6;
    

  }else{
  
  if (!this.doctorPagination[doctorId]) {
    this.doctorPagination[doctorId] = 6; 
  } else {
    this.doctorPagination[doctorId] += 6; 
  }}

  this.oldDocId = doctorId;
  this.doctorLists.find(x => x.doctorId == doctorId).slotList = this.getDoctorSlots(doctorId, this.doctorLists.find(x => x.doctorId == doctorId).dayOfWeek)
}

hasPreviousSlots(doctorId: string): boolean {
  if (!doctorId) return false;

  const currentPage = this.doctorPagination[doctorId] || 0;
  return currentPage >= 6;
}

loadPreviousPage(doctorId: string) {
  if ((this.doctorPagination[doctorId] || 0) > 0) {
    this.doctorPagination[doctorId] = this.doctorPagination[doctorId] - 6;
    this.doctorLists.find(x => x.doctorId == doctorId).slotList = this.getDoctorSlots(doctorId, this.doctorLists.find(x => x.doctorId == doctorId).dayOfWeek)
  }
}

loadData(flag){
  this.mental=false;
  this.primary=false;
  this.vaccineFlag = false;
  if(flag=='Vaccine'){
    this.vaccineFlag = true;
  }else{
     if(flag=='mental'){
      this.consulationList=this.mentalHealth;
      this.mentalplace='Choose a Mental Health Condition'
      this.mental=true;
     }else{
      this.mentalplace='Choose a Symptoms/Diseases'
      this.primary=true;
      this.consulationList=this.primaryCare;}
  }
this.bookingPlatFormApp?.reset();
this.resetOnload();
}

sendVisit(doctorId: string, date: Date, slot: string, visitType: string, duration: any) {
  this.isBookAndReview = 'review'
  this.visitDetails = {
    doctorId,
    date,
    slot,
    visitType,
    duration
  }; 
}

searchDoctor() {
  const searchName = (this.bookingPlatFormApp.get('departmentOrDoctor')?.value ||"").toLowerCase();
  const location = (this.bookingPlatFormApp.get('location')?.value||"").toLowerCase();

  this.doctorLists = this.originalDoctorLists.filter(d => {
    const matchName = searchName ? d.doctorName.toLowerCase().includes(searchName) : true;
    const matchCity = location ? d.hospitalCity.toLowerCase().includes(location) : true;
    return matchName && matchCity;
  });
}

gotoBooking() {
  this.isDocDetailsVisible = false;
  this.isBookAndReview = 'booking';
}

onClickDocDetails(docDetail){
  this.isBookAndReview = '';
  this.selectedDocId = docDetail.doctorId;
  this.selectedTenantId = docDetail.tenantId;
  this.selectedImageLink = docDetail.imageLink;
  this.isDocDetailsVisible = true;
}


}
